
export const TOP_SUPPLIERS: string[] = ['Expedia', 'Hotels.com', 'Booking.com'];
export const HOTEL_SUPPORT_EMAIL = 'hotelsupport@membergetaways.com';

export const NON_REFUNDABLE_TYPE = 'nonrefundable';
export const REFUNDABLE_TYPE = 'refundable';
